var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalViews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "overview",
    d: "M23.7,18.549A7.892,7.892,0,0,0,17,15a7.891,7.891,0,0,0-6.7,3.549,1.687,1.687,0,0,0,0,1.9A7.894,7.894,0,0,0,17,24a7.892,7.892,0,0,0,6.7-3.549,1.689,1.689,0,0,0,0-1.9ZM17,21.5a2,2,0,1,1,2-2A2,2,0,0,1,17,21.5Zm-8.362.072a3.682,3.682,0,0,1,0-4.146A9.842,9.842,0,0,1,17,13a9.724,9.724,0,0,1,7,2.8V5a5,5,0,0,0-5-5H5A5,5,0,0,0,0,5V18a5,5,0,0,0,5,5H9.8A10.676,10.676,0,0,1,8.638,21.572ZM11,5h7a1,1,0,0,1,0,2H11a1,1,0,0,1,0-2Zm0,5h7a1,1,0,0,1,0,2H11a1,1,0,0,1,0-2ZM6.5,4.5A1.5,1.5,0,1,1,5,6,1.5,1.5,0,0,1,6.5,4.5Zm0,5A1.5,1.5,0,1,1,5,11,1.5,1.5,0,0,1,6.5,9.5Zm0,8A1.5,1.5,0,1,1,8,16,1.5,1.5,0,0,1,6.5,17.5Z",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViews);
export default __webpack_public_path__ + "static/media/total-views.99134cb8c14141e59bd6fbff88e3333b.svg";
export { ForwardRef as ReactComponent };